import { type ArrayOfObjects } from '../types/ArrayOfObjects';
import { getIterableArrayOfObjects } from '../utils/getIterableArrayOfObjects';

import { LOCATION } from './regions';

type PhotoScheme = {
  title: string;
  imageSrc: string;
  description: string;
};

export type SeriaPlusScheme = {
  watchObjectsLink: string;
  title: string;
  sectionTabTitle: string;
  media: ArrayOfObjects<PhotoScheme>;
  description: string;
};

export type SeriaPlusByLocationScheme = Record<number, SeriaPlusScheme>;

const media = getIterableArrayOfObjects<PhotoScheme>([
  {
    description:
      'Наслаждайтесь ужинами под открытым небом, работайте удалённо с видом на город или просто отдыхайте, любуясь окружающим пейзажем. Для вашего удобства на террасе выполнена гидроизоляция пола, проведено освещение и установлены розетки.',
    imageSrc: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus_v2/terraces.jpg',
    title: 'Террасы',
  },
  {
    description:
      'Естественный свет — важнейшее условие здоровья и продуктивности. Поэтому дома «Серии плюс» отличаются разнообразием остекления. Окна наполняют квартиру дневным светом и делают пространство более уютным.',
    imageSrc:
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus_v2/floor-to-ceiling-windows.jpg',
    title: 'Окна в пол',
  },
  {
    description:
      'В кварталах «Серии плюс» представлены балконы разных форм: полукруглые, трапециевидные, угловые. Снаружи они придают фасадам особую динамику, а в квартире появляется дополнительная зона отдыха.',
    imageSrc: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus_v2/balconies.jpg',
    title: 'Балконы',
  },
  {
    description:
      'Просторные, светлые лобби с высокими потолками и витражным остеклением ежедневно встречают жителей в кварталах «Серии плюс». Продуманная планировка включает удобную зону для ожидания, гостевой санузел и место для хранения колясок и велосипедов.',
    imageSrc: 'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus_v2/modern-lobby.jpg',
    title: 'Современное лобби',
  },
  {
    description:
      'Каждая деталь отличается функциональностью и эстетикой. Индивидуальная пластика фасадов создаёт современный архитектурный облик, а панорамное остекление делает солнце частью вашего интерьера.',
    imageSrc:
      'https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/seria_plus_v2/thoughtful-architecture.jpg',
    title: 'Продуманная архитектура',
  },
]);

const title = 'О «Серии плюс»';
const sectionTabTitle = 'Серия плюс';
const description =
  '«Серия плюс» — кварталы ПИК для тех, кто ценит индивидуальность: проекты объединяют уникальную выразительную архитектуру и тщательно спланированную инфраструктуру.';

export const seriaPlusByLocation: SeriaPlusByLocationScheme = {
  [LOCATION.MOSCOW_AND_AREA.ID]: {
    description,
    media,
    sectionTabTitle,
    title,
    watchObjectsLink:
      'https://www.cian.ru/newobjects/list/?deal_type=sale&engine_version=2&newobject%5B0%5D=1656204&newobject%5B1%5D=1736872&newobject%5B2%5D=20063&newobject%5B3%5D=2159741&newobject%5B4%5D=2251726&newobject%5B5%5D=2764045&newobject%5B6%5D=3499138&newobject%5B7%5D=3663814&newobject%5B8%5D=3804713&newobject%5B9%5D=3961302&newobject%5B10%5D=4102935&newobject%5B11%5D=4601606&newobject%5B12%5D=4726516&newobject%5B13%5D=4958260&newobject%5B14%5D=5604043&newobject%5B15%5D=5686240&newobject%5B16%5D=5703245&offer_type=newobject&region=-1',
  },
  [LOCATION.SPB_AND_AREA.ID]: {
    description,
    media,
    sectionTabTitle,
    title,
    watchObjectsLink:
      'https://spb.cian.ru/newobjects/list/?deal_type=sale&engine_version=2&newobject%5B0%5D=3878565&newobject%5B1%5D=4065973&offer_type=newobject&region=-2',
  },
};
